import { useRef } from "react";

// Has this form changed since it opened, or since it was last saved? An edit form's Save button is offered only then, so
// nobody presses Save on something they did not touch and nobody has to guess what a save would change.
//
//   const [changed, markSaved] = useChanged(form);
//   <Button disabled={busy || !changed} onClick={save}>Save</Button>     // and call markSaved() after a successful save
//
// `values` is the object (or primitive) holding everything the person can edit. It is compared by value, so putting a value
// back where it was turns Save off again.
export function useChanged(values) {
  const now = JSON.stringify(values);
  const saved = useRef(now);
  return [differs(saved.current, now), () => { saved.current = now; }];
}

// The comparison itself, on two JSON strings (kept apart so it can be tested without a renderer).
export const differs = (savedJson, nowJson) => savedJson !== nowJson;
